import React, { useEffect, useState } from "react";
import styles from './App.module.css';

import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";

import PagamentoAluguel from './pages/PagamentoAluguel';
import PlayerPage from './pages/PlayerPage';
import SearchPage from './pages/SearchPage';

import Landing from "./pages/Landing";
import Home from "./pages/Index";
import HomePage from "./pages/HomePage";
import Shows from "./pages/Shows";
import Filmes from "./pages/Filmes";
import Series from "./pages/Series";
import Resenhas from "./pages/Resenhas";
import MinhaLista from "./pages/MinhaLista";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Pagamento from "./pages/Pagamento";
import FasClubes from "./pages/FasClubes";
import FasClubeCadastro from "./pages/FasClubeCadastro";
import FasClubeDetalhe from "./pages/FasClubeDetalhe";
import Social from "./pages/Social";
import Tickets from "./pages/Tickets";
import Watch from "./pages/Watch";

import PrivateRoute from "./components/PrivateRoute";
import AuthRedirect from "./components/AuthRedirect";
import RustChat from "./components/RustChat";

const queryClient = new QueryClient();

const App = () => {
  const [auth, setAuth] = useState<boolean>(() => {
    return localStorage.getItem("security-auth") === "true";
  });

  const [form, setForm] = useState({ username: "", password: "" });
  const [appReady, setAppReady] = useState(false);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    requestAnimationFrame(() => {
      setAppReady(true);
      if (preloader) {
        preloader.style.opacity = "0";
        setTimeout(() => preloader.remove(), 500);
      }
    });
  }, []);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    const validUser = form.username.trim().toLowerCase() === "k";
    const validPass = form.password.trim() === "2025";

    if (validUser && validPass) {
      localStorage.setItem("security-auth", "true");
      setAuth(true);
    } else {
      alert("Usuário ou senha incorretos!");
    }
  };

  if (!appReady) return null;

  if (!auth) {
    return (
      <div className={styles.appRoot}>
        <img src="/xtream.png" alt="Kakttus Solutions" className={styles.logo} />
        <h2>Projeto em Andamento</h2>
        <form onSubmit={handleLogin} className={styles.form}>
          <input
            type="text"
            placeholder="Usuário"
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
            className={styles.input}
          />
          <input
            type="password"
            placeholder="Senha"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className={styles.input}
          />
          <button type="submit" className={styles.button}>Entrar</button>
        </form>
      </div>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <RustChat />
          <Routes>
            <Route path="/" element={<AuthRedirect />} />
            <Route path="/landing" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/pagamento" element={<Pagamento />} />
            <Route path="/search" element={<PrivateRoute><SearchPage /></PrivateRoute>} />
            <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
            <Route path="/home2" element={<PrivateRoute><HomePage /></PrivateRoute>} />
            <Route path="/shows" element={<PrivateRoute><Shows /></PrivateRoute>} />
            <Route path="/filmes" element={<PrivateRoute><Filmes /></PrivateRoute>} />
            <Route path="/series" element={<PrivateRoute><Series /></PrivateRoute>} />
            <Route path="/resenhas" element={<PrivateRoute><Resenhas /></PrivateRoute>} />
            <Route path="/minha-lista" element={<PrivateRoute><MinhaLista /></PrivateRoute>} />
            <Route path="/fas-clubes" element={<PrivateRoute><FasClubes /></PrivateRoute>} />
            <Route path="/fas-clube/cadastro" element={<PrivateRoute><FasClubeCadastro /></PrivateRoute>} />
            <Route path="/fas-clube/:id" element={<PrivateRoute><FasClubeDetalhe /></PrivateRoute>} />
            <Route path="/social" element={<PrivateRoute><Social /></PrivateRoute>} />
            <Route path="/tickets" element={<PrivateRoute><Tickets /></PrivateRoute>} />
            <Route path="/watch/:embedId" element={<PrivateRoute><Watch /></PrivateRoute>} />
            <Route path="/pagamento-aluguel/:id" element={<PagamentoAluguel />} />
            <Route path="/player/:id" element={<PrivateRoute><PlayerPage /></PrivateRoute>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
